"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFormMovingInRequestIdState = exports.anyMeterByRegistrationNumber = exports.anyMeterBySerialNumber = exports.getMetersByAddress = exports.getBillingDqeAddress = exports.getMeterDqeAddress = exports.getMeterSerialCheck = exports.getFormNumberOfInhabitantsState = exports.getFormCommuneInseeCodeState = exports.getWaterChargeBySelectedCommune = exports.getEstimatedMonthlyPaiementState = exports.getDeliveryPointAddressState = exports.getCommuneSuggestions = exports.getWaterUsageTypes = exports.getOwnershipTypes = exports.getPaymentTypes = exports.getResidenceTypes = exports.getCityAutoCompleteState = exports.getCountryAutoCompleteState = exports.getCommuneAutoCompleteState = exports.getPaymentInformations = exports.getSubscriptionState = exports.getSubscriptionForm = void 0;
var i18n_1 = __importStar(require("../i18n"));
var settingsSelectors_1 = require("./settingsSelectors");
/**
 * récupere le formulaire à envoyer vers le back
 * @param {*} store Store redux hébergeant le state
 */
function getSubscriptionForm(states) {
    return states.moveIn.formData;
}
exports.getSubscriptionForm = getSubscriptionForm;
/**
 * récupere l'etat actuel de l'appel vers le back pour la souscription
 * @param {*} store Store redux hébergeant le state
 */
function getSubscriptionState(states) {
    return states.moveIn.subscribe;
}
exports.getSubscriptionState = getSubscriptionState;
/**
 * récupere l'etat actuel de l'appel vers le back pour la souscription
 * @param {*} store Store redux hébergeant le state
 */
function getPaymentInformations(states) {
    return states.moveIn.paymentInformations;
}
exports.getPaymentInformations = getPaymentInformations;
/**
 * récupere l'etat actuel de l'appel vers le back pour l'autoCompletion de la commune
 * @param {*} store Store redux hébergeant le state
 */
function getCommuneAutoCompleteState(states) {
    return states.moveIn.communeAutoComplete;
}
exports.getCommuneAutoCompleteState = getCommuneAutoCompleteState;
/**
 * récupere l'etat actuel de l'appel vers le back pour l'autoCompletion de la commune
 * @param {*} store Store redux hébergeant le state
 */
function getCountryAutoCompleteState(states) {
    return states.moveIn.countryAutoComplete;
}
exports.getCountryAutoCompleteState = getCountryAutoCompleteState;
/**
 * récupere l'etat actuel de l'appel vers le back pour l'autoCompletion de la commune
 * @param {*} store Store redux hébergeant le state
 */
function getCityAutoCompleteState(states) {
    return states.moveIn.cityAutoComplete;
}
exports.getCityAutoCompleteState = getCityAutoCompleteState;
/**
 * récupere les valeurs de la liste déroulante pour le type de résidence
 * @param {*} store Store redux hébergeant le state
 */
function getResidenceTypes(states) {
    var lang = (0, settingsSelectors_1.getLanguage)(states);
    var translation = (0, i18n_1.default)(lang ? lang : i18n_1.langTypes.FR);
    return [
        { id: 0, label: translation.moveIn.residenceInfos.residenceTypes.main, value: "Main" },
        { id: 1, label: translation.moveIn.residenceInfos.residenceTypes.secondary, value: "Secondary" },
        { id: 2, label: translation.moveIn.residenceInfos.residenceTypes.commercial, value: "Commercial" },
        { id: 3, label: translation.moveIn.residenceInfos.residenceTypes.mixed, value: "Mixed" },
    ];
}
exports.getResidenceTypes = getResidenceTypes;
/**
 * récupere les valeurs de la liste déroulante pour le type de facturation
 * @param {*} store Store redux hébergeant le state
 */
function getPaymentTypes(states) {
    var lang = (0, settingsSelectors_1.getLanguage)(states);
    var translation = (0, i18n_1.default)(lang ? lang : i18n_1.langTypes.FR);
    return [
        { id: 1, label: translation.moveIn.paymentInfos.paymentTypes.monthly, value: "Monthly" },
        { id: 2, label: translation.moveIn.paymentInfos.paymentTypes.bill, value: "Bill" },
        { id: 3, label: translation.moveIn.paymentInfos.paymentTypes.other, value: "Other" }
    ];
}
exports.getPaymentTypes = getPaymentTypes;
/**
 * récupere les valeurs de la liste des radio box disponible pour le type de propriètaire
 * @param {*} store Store redux hébergeant le state
 */
function getOwnershipTypes(states) {
    var lang = (0, settingsSelectors_1.getLanguage)(states);
    var translation = (0, i18n_1.default)(lang ? lang : i18n_1.langTypes.FR);
    return [
        { id: "Owner", label: translation.moveIn.residenceInfos.ownershipTypes.owner, value: "Owner" },
        { id: "Renter", label: translation.moveIn.residenceInfos.ownershipTypes.renter, value: "Renter" },
    ];
}
exports.getOwnershipTypes = getOwnershipTypes;
/**
 * récupere les valeurs de la liste déroulante pour le type d'utilisation d'eau
 * @param {*} store Store redux hébergeant le state
 */
function getWaterUsageTypes(states) {
    var lang = (0, settingsSelectors_1.getLanguage)(states);
    var translation = (0, i18n_1.default)(lang ? lang : i18n_1.langTypes.FR);
    return [
        { id: 0, label: translation.moveIn.residenceInfos.waterUsageTypes.domestical, value: "Domestical" },
        { id: 1, label: translation.moveIn.residenceInfos.waterUsageTypes.professional, value: "Professional" },
        { id: 2, label: translation.moveIn.residenceInfos.waterUsageTypes.industrial, value: "Industrial" },
    ];
}
exports.getWaterUsageTypes = getWaterUsageTypes;
/**
 * récupere la liste des suggestions pour l'autoCompletion de la commune
 * @param {*} store Store redux hébergeant le state
 */
function getCommuneSuggestions(states) {
    return states.moveIn.communeAutoComplete.communeSuggestions;
}
exports.getCommuneSuggestions = getCommuneSuggestions;
/**
 * récupere l'etat  de l'appel vers le back concernant l'addresse du point de fourniture
 * @param {*} store Store redux hébergeant le state
 */
function getDeliveryPointAddressState(states) {
    return states.moveIn.deliveryPointAddressSearch;
}
exports.getDeliveryPointAddressState = getDeliveryPointAddressState;
/**
 * récupere l'etat  de l'appel vers le back concernant la récupération de l'estimation de la consommation
 * @param {*} store Store redux hébergeant le state
 */
function getEstimatedMonthlyPaiementState(states) {
    return states.moveIn.estimatedMonthlyPaiement;
}
exports.getEstimatedMonthlyPaiementState = getEstimatedMonthlyPaiementState;
/**
 * récupere l'etat  de l'appel vers le back concernant la récupération du prix du m3 d'eau selon la commune
 * @param {*} store Store redux hébergeant le state
 */
function getWaterChargeBySelectedCommune(states) {
    return states.moveIn.waterCharge;
}
exports.getWaterChargeBySelectedCommune = getWaterChargeBySelectedCommune;
/**
 * récupere l'insee code de la commune sélectionnée par le client
 * @param {*} store Store redux hébergeant le state
 */
function getFormCommuneInseeCodeState(states) {
    return states.moveIn.formData.inseeCode;
}
exports.getFormCommuneInseeCodeState = getFormCommuneInseeCodeState;
/**
 * récupere le nombre de personnes dans le foyer saisi par le client
 * @param {*} store Store redux hébergeant le state
 */
function getFormNumberOfInhabitantsState(states) {
    var _a;
    return (_a = states.moveIn.formData.residence) === null || _a === void 0 ? void 0 : _a.numberOfInhabitants;
}
exports.getFormNumberOfInhabitantsState = getFormNumberOfInhabitantsState;
/**
 * récupere l'etat de vérification de numéro de série du compteur
 * @param {*} store Store redux hébergeant le state
 */
function getMeterSerialCheck(states) {
    return states.moveIn.deliveryPointAddressSearch;
}
exports.getMeterSerialCheck = getMeterSerialCheck;
/**
 * récupere la valeur de l'addresse du compteur selectionner sur dqe
 * @param {*} store Store redux hébergeant le state
 */
function getMeterDqeAddress(states) {
    return states.moveIn.dqeSuggestionMeterAddress;
}
exports.getMeterDqeAddress = getMeterDqeAddress;
/**
 * récupere la valeur de l'addresse de corrspondace selectionner sur dqe
 * @param {*} store Store redux hébergeant le state
 */
function getBillingDqeAddress(states) {
    return states.moveIn.dqeSuggestionBillingAddress;
}
exports.getBillingDqeAddress = getBillingDqeAddress;
/**
 * récupere l'etat  de l'appel vers le back concernant la récupération des compteurs selon l'adresse
 * @param {*} store Store redux hébergeant le state
 */
function getMetersByAddress(states) {
    return states.moveIn.meterSuggestions;
}
exports.getMetersByAddress = getMetersByAddress;
/**
 * récupere l'etat  de l'appel vers le back concernant la vérification si le compteur existe selon le serial number
 * @param {*} store Store redux hébergeant le state
 */
function anyMeterBySerialNumber(states) {
    return states.moveIn.meterExistsBySerialNumber;
}
exports.anyMeterBySerialNumber = anyMeterBySerialNumber;
/**
 * récupere l'etat  de l'appel vers le back concernant la vérification si le compteur existe selon le registration number
 * @param {*} store Store redux hébergeant le state
 */
function anyMeterByRegistrationNumber(states) {
    return states.moveIn.meterExistsByRegistrationNumber;
}
exports.anyMeterByRegistrationNumber = anyMeterByRegistrationNumber;
/**
 * récupere l'id de la moving in request pour faire le suivi
 * @param {*} store Store redux hébergeant le state
 */
function getFormMovingInRequestIdState(states) {
    return states.moveIn.formData.movingInRequestId;
}
exports.getFormMovingInRequestIdState = getFormMovingInRequestIdState;
